import { lazy, FC, Suspense } from 'react';
import { Route, Routes, Navigate } from 'react-router';
import { MasterLayout } from '../../_metronic/layout/MasterLayout';
import TopBarProgress from 'react-topbar-progress-indicator';
import { getCSSVariableValue } from '../../_metronic/assets/ts/_utils';
import { WithChildren } from '../../_metronic/helpers';

const PrivateRoutes = () => {
  const ProfileWrapper = lazy(() => import('../modules/profile/ProfileWrapper'));
  const DashboardWrapper = lazy(() => import('../modules/dashboard/DashboardWrapper').then(module => ({ default: module.DashboardWrapper })));
  const BouncedDocumentsWrapper = lazy(() => import('../modules/documents/bouncedDocuments/BouncedDocumentsWrapper'));
  const DocumentsWrapper = lazy(() => import('../modules/documents/DocumentsWrapper'));
  const OrdersWrapper = lazy(() => import('../modules/orders/OrdersWrapper'));
  const SystemStatus = lazy(() => import('../modules/systemStatus/SystemStatus'));
  const DocumentDetailsWrapper = lazy(() => import('../modules/documents/documentDetails/DocumentDetailsWrapper'));
  const OrderDetailsWrapper = lazy(() => import('../modules/orders/orderDetails/OrderDetailsWrapper'));

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        <Route path='*' element={<Navigate to='/dashboard' />} />

        {/* Pages */}
        <Route path='dashboard' element={<SuspensedView><DashboardWrapper /></SuspensedView>} />

        {/* Lazy Modules */}
        <Route
          path='profile/*'
          element={
            <SuspensedView>
              <ProfileWrapper />
            </SuspensedView>
          }
        />
        <Route
          path='documents/*'
          element={
            <SuspensedView>
              <DocumentsWrapper />
            </SuspensedView>
          }
        />
        <Route
          path='documents/bounced/*'
          element={
            <SuspensedView>
              <BouncedDocumentsWrapper />
            </SuspensedView>
          }
        />
        <Route
          path='orders/*'
          element={
            <SuspensedView>
              <OrdersWrapper />
            </SuspensedView>
          }
        />
        <Route
          path='orderDetails/:orderNumber'
          element={
            <SuspensedView>
              <OrderDetailsWrapper />
            </SuspensedView>
          }
        />
        <Route
          path='documentDetails/:documentNumber'
          element={
            <SuspensedView>
              <DocumentDetailsWrapper />
            </SuspensedView>
          }
        />
        <Route
          path='status/*'
          element={
            <SuspensedView>
              <SystemStatus />
            </SuspensedView>
          }
        />

        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  );
};

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue('--bs-primary');
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  });
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>;
};

export { PrivateRoutes };
